export default __webpack_public_path__ + "static/media/AnimacijaConversation_about_founding_a_company_BHS.b29de5eb.mp4";